export type VehiclePhotoRequestBody = {
  fileId: string;
};
